import { Button } from "@/components/Base/Button";
import { Icon } from "@/components/Common/Icon";
import { Tooltip } from "@/components/Common/Tooltip";
import { useInboxPanel } from "@/hooks/useInboxPanel";
import { useRoPanelParams } from "@/hooks/useRoPanelParams";
import { useTasksAnalytics } from "@/hooks/useTasksAnalytics";
import { IconNames } from "@/types/v2";
import { ICON_ONLY_HEADER_LINKS } from "@/lib/const";
import { MyOpenTasksBadgeCount } from "@/components/Tasks/MyOpenTasksBadgeCount";

const TASKS_TAB = "tasks";

export const TasksBellTrigger = () => {
  const { isOpen, openPanel } = useInboxPanel();
  const { setActiveTab } = useRoPanelParams();
  const { logTasksTabOpened } = useTasksAnalytics();

  return (
    <Button
      className="relative rounded-md text-base hover:bg-slate-200"
      variant="ghost-primary"
      size={ICON_ONLY_HEADER_LINKS ? "lgIcon" : "default"}
      onClick={() => {
        openPanel();
        setActiveTab(TASKS_TAB);
        logTasksTabOpened("bell");
      }}
      aria-expanded={isOpen}
      aria-controls="inbox-panel"
    >
      <Tooltip message="My open tasks" asChild={false}>
        <Icon
          name={IconNames.bell}
          className="cursor-pointer hover:opacity-70"
          size={20}
        />
      </Tooltip>
      {!isOpen && <MyOpenTasksBadgeCount />}
    </Button>
  );
};
